/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { clearData } from '../../utils/localStorage';

export interface AccountState {
  status: 'idle' | 'loading' | 'success' | 'error';
  mobileNumber: number | null;
  verifyToken: string | null;
  authToken: string | null;
  isOtpResent: boolean | null;
  isOtpVerified:boolean | null,
  userDetails: any;
  isStepChanged: boolean;
  error: {
    isError: boolean,
    message: string | null
  }
}

// Initial State
const initialState: AccountState = {
  status: 'idle',
  mobileNumber: null,
  verifyToken: null,
  authToken: null,
  isOtpResent: null,
  isOtpVerified: null,
  userDetails: {},
  isStepChanged: false,
  error: {
    isError: false,
    message: '',
  },
};

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    getUserDetails: (state) => {},
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    logout: (state) => {
      clearData();
      state.status = 'success';
      state.mobileNumber = null;
      state.verifyToken = null;
      state.authToken = null;
      state.isOtpResent = null;
      state.userDetails = {};
      state.error = {
        isError: false,
        message: '',
      };
    },
    setMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    generateOTP: (state, action) => {
    },
    verifyOTP: (state, action) => {},
    setOtpVerified: (state, action) => {
      state.isOtpVerified = action.payload;
    },
    setAuthCredentials: (state, action) => {
      state.mobileNumber = action.payload.mobileNumber;
      state.authToken = action.payload.authToken;
      state.verifyToken = null;
      state.status = action.payload.status || 'success';
    },
    setGenerateOTPInfo: (state, action) => {
      state.mobileNumber = action.payload.mobileNumber;
      state.verifyToken = action.payload.verifyToken;
      state.status = 'success';
      // state.isOtpResent = true;
    },
    setNextStep: (state, action) => {
      state.userDetails.nextStep = action.payload;
    },
    setAccountStatus: (state, action) => {
      state.status = action.payload;
    },
    setAccountError: (state, action) => {
      state.status = 'error';
      state.error = action.payload;
    },
    verifyPrevTokenAndGetUserDetails: (state, action) => { },
    setVerifiedTokenAndUserDetails: (state, action) => {
      state.mobileNumber = action.payload.userDetails.phone;
      state.authToken = action.payload.authToken;
      state.userDetails = action.payload.userDetails;
      state.status = 'success';
    },
    resendOtp: (state, action) => {},
    resendOtpSuccess: (state, action) => {
      state.isOtpResent = action.payload;
      state.status = 'success';
    },
    resendOtpFailure: (state, action) => {
      state.isOtpResent = action.payload;
      state.status = 'error';
    },
    clearAccountError: (state) => {
      state.error = {
        isError: false,
        message: '',
      };
      state.status = 'idle';
      state.isOtpResent = null;
      state.isOtpVerified = null;
    },
    clearGenerateOTPInfo: (state) => {
      state.verifyToken = null;
    },
    previousStep: (state, action) => {
    },
    setPreviousStep: (state, action) => {
      state.userDetails.currentStep = action.payload;
      state.isStepChanged = true;
    },
    clearPreviousStep: (state, action) => {
      state.isStepChanged = false;
    },
  },
});

// Action
export const {
  verifyOTP, setAuthCredentials, generateOTP, setGenerateOTPInfo, clearGenerateOTPInfo,
  setAccountStatus, setAccountError, clearAccountError, logout, setNextStep,
  getUserDetails, setUserDetails, verifyPrevTokenAndGetUserDetails,
  setVerifiedTokenAndUserDetails, setPreviousStep, previousStep, clearPreviousStep, setOtpVerified,
  resendOtp, resendOtpSuccess, resendOtpFailure, setMobileNumber,
} = accountSlice.actions;

export default accountSlice.reducer;
